import { Component, OnInit, Input } from '@angular/core'
import { IUserBooking } from 'app/amendment/bookings/bookings.interfaces'
import { LayoutState } from 'app/shared/layout/layout-state'

@Component({
    selector: 'sbw-booking-list',
    templateUrl: './booking-list.component.html',
    styleUrls: ['./booking-list.component.css']
})
export class BookingListComponent {

    displayedBookings: IUserBooking[]

    get hasMore(): boolean { return this.displayedBookings.length < this._bookings.length }
    @Input() set bookings(b: IUserBooking[]) {
        this.displayedBookings = b.slice(0, 5)
        this._bookings = b
    }
    get bookings(): IUserBooking[] { return this._bookings }

    _bookings: IUserBooking[]

    constructor(private layoutState: LayoutState) {}

    showMore() {
        this.displayedBookings = this.bookings
    }

    routerAction(booking: IUserBooking): string {
        return `/amendment/booking/${booking.code}`
    }

    changeStep() {
        this.layoutState.setIsContentLoaded(false)
    }
}
